import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyCJQq_d7oUs4hZHYM1YC9jQ7IKni1iGTxk',
  authDomain: 'bmed-a08c3.firebaseapp.com',
  projectId: 'bmed-a08c3',
  storageBucket: 'bmed-a08c3.firebasestorage.app',
  messagingSenderId: '969063715284',
  appId: '1:969063715284:web:f04b79473c0e28c610c641',
  measurementId: 'G-CXJKVT13BT',
}

const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)
